import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "C:/Users/yrsha/client1/src/assets/Taas Logo.png"; // Update with the correct path

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false); // State for mobile navbar toggle
  const navigate = useNavigate();
  const location = useLocation();

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const closeNavbar = () => {
    setIsOpen(false);
  };

  // Scroll to specific service sections
  const handleScroll = (id) => {
    closeNavbar();
    if (location.pathname !== "/services") {
      navigate("/services");
    }
    setTimeout(() => {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 200);
  };
// Function to always scroll to the top
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
  return (
    <>
      {/* CSS for fixed navbar, animations, and hover effects */}
      <style>
        {`
          .navbar {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            transition: background 0.3s ease-in-out;
            font-family: 'Poppins', sans-serif;
          }

          .nav-link {
            font-weight: bold;
            transition: color 0.3s ease, transform 0.3s ease;
          }

          .nav-link:hover {
            color: #ff8c00 !important;
            transform: scale(1.1);
          }

          .dropdown-item {
            font-weight: bold;
            transition: color 0.3s ease, background 0.3s ease;
          }

          .dropdown-item:hover {
            color: #ff8c00 !important;
            background-color: transparent;
            transform: scale(1.05);
          }

          .navbar-toggler {
            border: none;
            outline: none;
            transition: transform 0.3s ease;
          }

          .navbar-toggler:focus {
            box-shadow: none;
          }

          .navbar-toggler:hover {
            transform: rotate(90deg);
          }

          .dropdown-menu {
            animation: fadeIn 0.3s ease-in-out;
          }

          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>

      <nav className="navbar navbar-expand-lg navbar-light bg-white">
        <div className="container-fluid">
          {/* Brand/Logo */}
          <Link className="navbar-brand" to="/Home" onClick={closeNavbar}>
            <img src={logo} alt="Taas Logo" style={{ height: "35px", width: "auto",marginLeft: "30px"  }} />
          </Link>

          {/* Mobile Toggle Button */}
          <button
            className={`navbar-toggler ${isOpen ? "" : "collapsed"}`}
            type="button"
            onClick={toggleNavbar}
            aria-controls="navbarNav"
            aria-expanded={isOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navigation Links */}
          <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/Home" onClick={() => { closeNavbar(); scrollToTop(); }}>
                  Home
                </Link>
              </li>
              
              <li className="nav-item">
              <Link className="nav-link" to="/about" onClick={() => { closeNavbar(); scrollToTop(); }}>
                  About Us
                </Link>
              </li>

              {/* Dropdown for Services */}
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="servicesDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Services
                </a>
                
                <ul className="dropdown-menu" aria-labelledby="servicesDropdown">
                  <li>
                    <button className="dropdown-item" onClick={() => handleScroll("motor-rewinding")}>
                      Motor Rewinding Services
                    </button>
                  </li>
                  <li>
                    <button className="dropdown-item" onClick={() => handleScroll("water-pump")}>
                      Water Pump Repair
                    </button>
                  </li>
                  <li>
                    <button className="dropdown-item" onClick={() => handleScroll("compressor")}>
                      Compressor Repair and Service
                    </button>
                  </li>
                  <li>
                    <button className="dropdown-item" onClick={() => handleScroll("mechanical-seals")}>
                      Mechanical Seals
                    </button>
                  </li>
                  <li>
                    <button className="dropdown-item" onClick={() => handleScroll("generator-repair")}>
                      Generator Repair
                    </button>
                  </li>
                  <li>
                    <button className="dropdown-item" onClick={() => handleScroll("heresite-coating")}>
                      Heresite Coating
                    </button>
                  </li>
                  <li>
                    <button className="dropdown-item" onClick={() => handleScroll("lathe-works")}>
                      Lathe Works
                    </button>
                  </li>
                </ul>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/contact" onClick={closeNavbar}>
                  Contact
                </Link>
              </li>

              {/* WhatsApp Button */}
              <li className="nav-item">
                <a
                  href="https://wa.me/971527499912"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-success ms-3"
                  style={{
                    fontSize: "12px",
                    lineHeight: "1.5",
                    marginTop: "5px",
                    fontWeight: "bold",
                  }}
                >
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
